import { render, staticRenderFns } from "./seoSettings.vue?vue&type=template&id=1414b05a&scoped=true"
import script from "./seoSettings.vue?vue&type=script&lang=js"
export * from "./seoSettings.vue?vue&type=script&lang=js"
import style0 from "./seoSettings.vue?vue&type=style&index=0&id=1414b05a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1414b05a",
  null
  
)

export default component.exports